import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import ICON_STEP_1 from 'assets/slickpay-splash/icon-step-1.svg';
import ICON_STEP_2 from 'assets/slickpay-splash/icon-step-2.svg';
import ICON_STEP_3 from 'assets/slickpay-splash/icon-step-3.svg';
import ICON_STEP_4 from 'assets/slickpay-splash/icon-step-4.svg';
import ICON_STEP_5 from 'assets/slickpay-splash/icon-step-5.svg';
import Button from 'components/form/Button.component';
import LINK from 'constants/link.const';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';
import linkTo from 'utils/links/linkTo.util';
import navFor from 'utils/links/navFor.util';
import logger from 'utils/logger.util';

import CN from './StepsBanner.module.scss';

const L = logger('StepsBanner');

const StepsBanner = () => {
  const history = useHistory();
  const salonId = useCurrentSalonId();
  const { t } = useTranslation();

  const nav = navFor('StepsBanner.handleSetUpAccountsClick()', { history });

  const handleSetUpAccountsClick = () => {
    const url = linkTo({
      pattern: LINK.salonOnline,
      params: { salonId },
    });

    const searchString = fromObjectToQueryString({ open: true });

    nav.push(`${url}?${searchString}`);
  };

  const openIntercom = useCallback(() => {
    L.debug('StepsBanner()', window);
    const el = window.Intercom;
    if (el) {
      L.info('openIntercom()', window);
      L.debug('openIntercom() -> el is:', el);
      window.Intercom('showNewMessage');
    }
  }, []);

  return (
    <div data-bem="StepsBanner" className={CN.container}>
      <span className={CN.bannerNumber}>{t('slickPay.ordered.stepsBanner.bannerNumber')}</span>
      <div className={CN.inner}>
        <div className={CN.title}>{t('slickPay.ordered.stepsBanner.title')}</div>
        <div className={CN.subtitle}>{t('slickPay.ordered.stepsBanner.subtitle')}</div>
        <table>
          <tbody>
            <tr>
              <td>
                <img src={ICON_STEP_1} alt="Step 1 - Switch on your card reader" className={CN.icon} />
              </td>
              <td>{t('slickPay.ordered.stepsBanner.step1')}</td>
            </tr>

            <tr>
              <td>
                <img src={ICON_STEP_2} alt="Step 2 - Connect it to your WiFi" className={CN.icon} />
              </td>
              <td>{t('slickPay.ordered.stepsBanner.step2')}</td>
            </tr>

            <tr>
              <td>
                <img src={ICON_STEP_3} alt="Step 3 - Register your reader" className={CN.icon} />
              </td>
              <td>
                {t('slickPay.ordered.stepsBanner.step3Part1')}
                <span className={CN.purple}>{t('slickPay.ordered.stepsBanner.step3Part2')}</span> {t('slickPay.ordered.stepsBanner.step3Part3')}
                <div className={CN.buttonContainer}>
                  <Button className={CN.button} onClick={openIntercom} variant="secondaryForce">
                    <span className={CN.underline}>{t('slickPay.ordered.stepsBanner.step3Button')}</span>
                  </Button>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <img src={ICON_STEP_4} alt="Step 4 - Start taking payments !" className={CN.icon} />
              </td>
              <td>
                {t('slickPay.ordered.stepsBanner.step4')}
                <div className={CN.buttonContainer}>
                  <Button className={CN.button} onClick={handleSetUpAccountsClick} variant="secondaryForce">
                    <span className={CN.underline}>{t('slickPay.ordered.stepsBanner.step4Button')}</span>
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <img src={ICON_STEP_5} alt="Step 5 - Start taking payments & tips!" className={CN.icon} />
              </td>
              <td>{t('slickPay.ordered.stepsBanner.step5')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StepsBanner;
